import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Checkbox from "@mui/material/Checkbox";
//Limitless imports
import { useExpertMessageReviewContext } from "../../../../../../expert";
const ExpertReviewSuffix = ({
  classes,
  dialogue
}) => {
  const {
    messageReviewDetails,
    updateDialogueVote
  } = useExpertMessageReviewContext();
  const isChecked = messageReviewDetails.dialogues[dialogue.dialogueId] ? true : false;
  const handleChange = () => {
    updateDialogueVote(dialogue.dialogueId, !isChecked);
  };
  return /*#__PURE__*/React.createElement(Checkbox, {
    id: `${dialogue.dialogueId}ReviewCheckbox`,
    checked: isChecked,
    onChange: handleChange,
    value: dialogue.dialogueId,
    color: "primary",
    className: classes.checkbox
  });
};
const styles = () => ({
  checkbox: {
    alignSelf: "center"
  }
});
export default withStyles(styles)(ExpertReviewSuffix);
ExpertReviewSuffix.propTypes = {
  classes: PropTypes.object.isRequired,
  dialogue: PropTypes.object.isRequired
};